import React, { useState, useEffect } from 'react';
import { DialogActions, DialogContent } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import AddressInput from './addressinput';
import { useTranslation } from 'react-i18next';

export default function AddressEditDialog(props) {
    const [address, setAddress] = useState(props.address);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    useEffect(() => {
        setAddress(props.address);
    }, [props.address]);

    const onSave = () => {
        props.save(address);
    };

    const onCancel = () => {
        props.cancel();
    };

    const addressChanged = (addr) => {
        setAddress(addr);
    };

    return (
        <Dialog
            aria-labelledby="simple-dialog-title"
            open={props.open}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <DialogContent dividers>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <AddressInput idBase={'addresseditdialog'} address={address} addressChanged={addressChanged} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" sx={{ bgcolor: 'grey.300', color: 'text.primary', '&:hover': { bgcolor: 'grey.400' } }} name="address-edit-cancel" onClick={onCancel}>
                    {t('buttons.cancel')}
                </Button>
                <Button variant="contained" color="primary" name="address-edit-save" onClick={onSave}>
                    {t('buttons.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
